module.exports = __webpack_public_path__ + "img/guangao01.c3f6a6d5.jpg";